import { documentReady, debouncer, playAudioSync, index, playBGMusic } from "../Utility/utils";
import { addAnimScrollTrigger } from "./animations";

const initializeBlock = ($block) => {
  const body = document.querySelector("body");

  // For backend, ensure we're targeting the actual block.
  if (!!$block[0]) {
    $block = $block[0];
  }

  const siteIntro = $block.classList.contains("site_intro") ? $block : $block.querySelector(".site_intro");
  const navPlay = siteIntro.querySelector(".site_intro__nav .with_audio");

  let progress = 0;

  function site_intro_slides() {
    const active = siteIntro.querySelector(".site_intro__slide.active")
      ? siteIntro.querySelector(".site_intro__slide.active")
      : siteIntro.querySelectorAll(".site_intro__slide")[0];
    const slideTimer = 3000;

    // Ensure active has active class
    active.classList.add("active");
    active.setAttribute("aria-hidden", "false");
    updateProgressBar(active);

    // Close on Skip Intro link click
    const skipLink = siteIntro.querySelector(".site_intro__skip");
    if (!!skipLink) {
      skipLink.addEventListener("click", function (e) {
        siteIntro.classList.remove("active");
        siteIntro.setAttribute("aria-hidden", "true");
        const audio = siteIntro.querySelector(".audioSync__audio audio");
        const audioSlide = siteIntro.querySelector(".audioPlaying");
        audio.pause();
        audio.currentTime = 0;
        if (!!audioSlide) {
          audioSlide.classList.remove("audioPlaying");
        }
        body.classList.remove("scroll-lock");
        addAnimScrollTrigger();
      });
    }

    if (!active.classList.contains("slide_2") && !!navPlay) {
      navPlay.classList.add("hide");
    }

    // If we're at the audio prompt slide slide, stop to allow for user interaction
    if (active.classList.contains("slide_2")) {
      const withAudioCTA = siteIntro.querySelectorAll(".with_audio");
      const withoutAudioCTA = active.querySelector(".without_audio");

      if (!!withAudioCTA) {
        withAudioCTA.forEach((cta) => {
          cta.addEventListener("click", function (e) {
            e.preventDefault();
            if (!!navPlay) {
              navPlay.classList.add("hide");
            }
            // active.nextElementSibling.querySelector('a').classList.add('hidden');
            change_slides(active);
            siteIntroAudio();

            // Also, start the site background music
            playBGMusic();
          });
        });
      }

      if (!!withoutAudioCTA) {
        withoutAudioCTA.addEventListener("click", function (e) {
          e.preventDefault();
          change_slides(active);
          siteIntroAudio(false);
        });
      }
    }
    // If there's another slide, change to it.
    else if (!!active.nextElementSibling && !active.nextElementSibling.classList.contains("site_intro__progress")) {
      setTimeout(function () {
        change_slides(active);
        site_intro_slides();
      }, slideTimer);
    }
    // Else, close the intro
    else if (!body.classList.contains("wp-admin")) {
      setTimeout(function () {
        siteIntro.classList.remove("active");
        siteIntro.setAttribute("aria-hidden", "true");
        addAnimScrollTrigger();
      }, slideTimer);
    }
  }
  site_intro_slides();

  // Change Slide Button
  const changeSlidesLinks = siteIntro.querySelectorAll(".next_slide");
  changeSlidesLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      change_slides();
      site_intro_slides();
    });
  });

  const change_slides = (active = false, toActive = false) => {
    if (!active) {
      active = siteIntro.querySelector(".site_intro__slide.active");
    }
    if (!toActive) {
      toActive = active.nextElementSibling;
    }

    active.classList.remove("active");
    active.setAttribute("aria-hidden", "true");

    toActive.classList.add("active");
    toActive.setAttribute("aria-hidden", "false");

    // Ensure to remove audioPlaying class from the audio slide, if it has it.
    siteIntro.querySelector(".audioSync").classList.remove("audioPlaying");

    updateProgressBar(toActive);
  };

  function updateProgressBar(toActive = false) {
    toActive = toActive ? toActive : siteIntro.querySelector(".site_intro__slide.active");
    const children = toActive.parentNode.querySelectorAll(".site_intro__slide");
    let index;
    for (var i = 0; i <= children.length; i++) {
      if (children[i] == toActive) {
        index = i + 1;
      }
    }
    const slideCount = siteIntro.querySelectorAll(".site_intro__slide").length;
    const progress = (index / slideCount) * 100 + "%";
    const progressBar = siteIntro.querySelector(".site_intro__progress");
    progressBar.style.setProperty("--progress", progress);
  }

  function siteIntroAudio(withAudio = true) {
    const active = siteIntro.querySelector(".site_intro__slide.audioSync");

    if (withAudio) {
      playAudioSync(active);
      active.classList.add("audioPlaying");
    }

    // Listen for the end of the audio clip to skip to the next slide.
    const audio = active.querySelector(".audioSync__audio audio");
    audio.addEventListener("ended", function () {
      active.classList.remove("audioPlaying");
      change_slides(active);
      site_intro_slides();
    });
  }

  // Site Intro Modal Trigger Links
  const siteIntroLinks = document.querySelectorAll(".site_intro__trigger");
  if (siteIntroLinks) {
    siteIntroLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const body = document.querySelector("body");

        siteIntro.classList.remove("active");
        navPlay.classList.remove("hide");
        body.classList.add("show_intro");

        // Ensure we're at the first slide
        const firstSlide = siteIntro.querySelector(".slide_2");
        change_slides((active = false), firstSlide);

        // Wait just a tad to allow for a smooth transition from display:none to display:block
        setTimeout(function () {
          siteIntro.classList.add("active");
        }, 30);

        // Close nav menu if it's open
        const nav = document.querySelector(".main-navigation");
        nav.classList.remove("active");
        nav.setAttribute("aria-hidden", "true");
      });
    });
  }

  // Admin Section Only
  if (body.classList.contains("wp-admin")) {
    const adminNav = siteIntro.querySelector(".admin_slide_navigation");
    const links = adminNav.querySelectorAll("a");
    links.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        const targetClass = item.getAttribute("data-slide");
        const target = siteIntro.querySelector(targetClass);

        if (target) {
          change_slides(false, target);

          // Ensure if audio is playing that it is stopped
          const audio = siteIntro.querySelector("audio");
          audio.pause();
          audio.currentTime = 0;

          // Reset text highlights, if any
          // const highlightedText = siteIntro.querySelectorAll('.highlighted');
          // if(highlightedText){
          //   highlightedText.forEach(item => {
          //     item.classList.remove('highlighted');
          //   });
          // }
        }
      });
    });

    // To make editing timing easier, animate the audio playback progress bar, and allow for scrubbing
  }
};

// Initialize the intro on the front end
documentReady((event) => {
  const body = document.querySelector("body");

  // Determine if intro should be played before loading the home page.
  // sessionStorage.removeItem("site_visited"); // TEMP FOR TESTING ONLY.DELETE THIS LINE WHEN COMPLETE.
  if (!sessionStorage.getItem("site_visited")) {
    // Add body class to show intro, if on home page
    if (body.classList.contains("home")) {
      body.classList.add("show_intro");
    }

    // Set session item
    sessionStorage.setItem("site_visited", true);
  }

  var intro = document.querySelector(".site_intro");
  if (!!intro) {
    initializeBlock(intro);
  }
});

// Initialize dynamic block preview (editor).
if (window.acf) {
  window.acf.addAction("render_block_preview/type=site-introduction", initializeBlock);
}
